module.exports = __webpack_public_path__ + "img/info2.bfee2b25.png";